<template>
    <div class="sustainable-component wage-dynamic-wagepart">


        <!--<div class="bg-success mb-3 p-3 rounded">vue component wage-dynamic-wagepart</div>-->


        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-12 col-md-6">

                    <table class="table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                        <thead>
                            <tr>
                                <th class="col-2">Faktornr.</th>
                                <th class="col-3">Faktornamn</th>
                                <th class="col-2">Omfattning</th>
                                <th class="col-2"></th>
                            </tr>

                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in dynamicFactors" :key="index">
                                <td class="col-2">
                                    <span>{{item.FactorNumber}}</span>
                                </td>
                                <td class="col-3">
                                    <span>{{item.FactorName}}</span>
                                </td>
                                <td class="col-3">
                                    <span>{{getExtentType(item.Extent)}}</span>
                                </td>
                                <td class="col-2">
                                    <div class="pull-right" style="" v-if="disabled == false">
                                        <div class="dropdown text-right pr-2">
                                            <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                ...
                                            </a>
                                            <div class="dropdown-menu dropdown-menu-right">
                                                <a href="javascript:void(0)" class="dropdown-item" @click="updateDynamicWagepart(item)">Ändra</a>
                                                <a href="javascript:void(0)" class="dropdown-item" @click="deleteFactor(item.DynamicFactorId)">Ta bort</a>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
                <div class="col-12 col-md-6">

                    <table class="table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                        <thead>
                            <tr>
                                <th class="col-11">Gradnr.</th>
                                <th class="col-1"></th>
                            </tr>

                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in dynamicGrades" :key="index">
                                <td>
                                    <span>{{item.GradeNumber}}</span>
                                </td>
                                <td>
                                    <div class="pull-right" style="" v-if="disabled == false">
                                        <div class="dropdown text-right pr-2">
                                            <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                ...
                                            </a>
                                            <div class="dropdown-menu dropdown-menu-right">
                                                <a href="javascript:void(0)" class="dropdown-item" @click="deleteGrade(item.DynamicFactorId, item.GradeNumber)">Ta bort</a>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>


                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6">
                    <v-form v-model="valid" ref="form">
                        <div class="container-fluid p-0">
                            <div class="row">
                                <div class="col">
                                    <v-text-field v-bind:disabled="disabled" bg-color="white" label="Faktornummer" :rules="[rules.positiveInteger]" v-model="factorNumber" variant="outlined"></v-text-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <v-text-field v-bind:disabled="disabled" bg-color="white" label="Faktornamn" :rules="[rules.required]" v-model="factorName" variant="outlined"></v-text-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <v-select v-bind:disabled="disabled" bg-color="white" variant="outlined" :rules="[rules.requiredNumberWithZero]" label="Omfattning" :items="extentTypes" v-model="selectedExtent" item-title="name" item-value="val"></v-select>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="addFactor">
                                        Skapa faktor
                                    </v-btn>
                                </div>
                            </div>

                        </div>
                    </v-form>

                </div>
                <div class="col-12 col-md-6">
                    <v-form v-model="valid" ref="form2">
                        <div class="container-fluid p-0">
                            <div class="row">
                                <div class="col">
                                    <v-select bg-color="white" variant="outlined" :rules="[rules.required]" label="Värderingsfaktor" :items="dynamicFactors" v-model="selectedFactor" item-title="FactorName" item-value="DynamicFactorId"></v-select>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <v-text-field v-bind:disabled="disabled" bg-color="white" label="Gradnummer" :rules="[rules.positiveInteger]" v-model="gradeNumber" variant="outlined"></v-text-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="addGrade">
                                        Skapa grad
                                    </v-btn>
                                </div>
                            </div>

                        </div>
                    </v-form>
                </div>
            </div>

        </div>
        <WageUpdateDynamicWagepart ref="wageUpdateDynamicWagepart" @updated="load"></WageUpdateDynamicWagepart>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>

<script>

    import WageService from "../../Services/WageService";
    import ValidationService from "../../Services/ValidationService";
    import WageUpdateDynamicWagepart from "./update/update-dynamic-wagepart.vue"
    import CommonSpinner from '../../common/common-spinner.vue'
    import { ref } from 'vue'
    import { getCurrentInstance } from 'vue'

    const wageUpdateDynamicWagepart = ref(null);
    const form = ref(null);
    const form2 = ref(null);
    
    
    
    export default {
        emits: ['updated'],
        name: 'wage-dynamic-wagepart',
        components: {
            WageUpdateDynamicWagepart,
            CommonSpinner
        },
        props: {
            model: Object,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            updateDynamicWagepart(item) {
                this.loading++;
                this.wageUpdateDynamicWagepart.open(item)
                this.loading--;
            },
            async load() {
                this.loading++;
                try {
                    await this.loadFactors();
                    if (this.dynamicFactors.length > 0 && this.selectedFactor == null)
                        this.selectedFactor = this.dynamicFactors[0].DynamicFactorId;
                    await this.loadGrades(this.selectedFactor);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadAfterGradeUpdate() {
                this.loading++;
                try {
                    await this.loadGrades(this.selectedFactor);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadFactors() {
                this.loading++;
                try {
                    this.dynamicFactors = await WageService.getDynamicFactors();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                 this.loading--;
            },
            async loadGrades(dynamicFactorId) {
                this.loading++;
                try {
                    this.dynamicGrades = await WageService.getDynamicGrades(dynamicFactorId);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async addFactor() {
                this.loading++;
                var result = await this.form.validate();
                if (result.valid != true)
                    return;
                try {
                    await WageService.addDynamicFactor(this.factorNumber, this.factorName, this.selectedExtent);
                    this.displaySnackBar("Sparat");
                    this.load();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            async addGrade() {
                this.loading++;
                var result = await this.form2.validate();
                if (result.valid != true)
                    return;
                try {
                    await WageService.addDynamicFactorGrade(this.selectedFactor, this.gradeNumber);
                    this.displaySnackBar("Sparat");
                    this.loadGrades(this.selectedFactor);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            async deleteFactor(dynamicFactorId) {
                if (confirm(" Är du säker att du vill radera faktorn?")) {
                    this.loading++;
                    try {
                        await WageService.deleteDynamicFactor(dynamicFactorId);
                        this.load();
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                    }
                    this.loading--;
                }
            },
            async deleteGrade(dynamicFactorGrade, gradeNumber) {
                if (confirm(" Är du säker att du vill radera graden?")) {
                    this.loading++;
                    try {
                        await WageService.deleteDynamicFactorGrade(dynamicFactorGrade, gradeNumber);
                        this.displaySnackBar("Borttaget");
                        this.loadGrades(this.selectedFactor);
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            getExtentType(type) {
                var ret = "";
                for (var i = 0; i < this.extentTypes.length; i++) {
                    if (this.extentTypes[i].val == type)
                        ret = this.extentTypes[i].short;
                }
                return ret;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },

        },
        data() {
            return {
                valid: false,
                rules: ValidationService.rules(),
                extentTypes: [
                    { short: "Alla", name: "0 - Alla", val: 0 },
                    { short: "Individ.", name: "1 - Individ", val: 1 },
                ],
                factorNumber: null,
                factorName: null,
                selectedFactor: null,
                selectedExtent:null,
                gradeNumber: null,
                dynamicGrades: [],
                dynamicFactors: [],
                internalModel: {
                    JobPositions: [],
                    BlockGrades: [],
                    WageFactorGrades: [],
                    WageFactors: [],
                },
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            selectedFactor: function (newVal) {
                this.loadGrades(newVal);
            },
        },
        mounted() {
            this.internalModel = this.model;
            this.load();
        },

        // eslint-disable-next-line
        setup(props, { emit }) {
            return { wageUpdateDynamicWagepart, form, form2 }
        }

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
